import { defineMessages } from 'react-intl';

/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const patternsPageMessages = defineMessages({
    title: {
        id: 'buildPane.patternsPage.title',
        defaultMessage: 'Patterns'
    },
    titleDescription: {
        id: 'buildPane.patternsPage.titleDescription',
        defaultMessage: 'Patterns are template utterances with placeholders for entities used to further improve your model.'
    },
    deletePatternsModalTitle: {
        id: 'luis.patternsPage.deletePatternsModalTitle',
        defaultMessage: 'Delete pattern(s)?'
    },
    deletePatternsModalDescription: {
        id: 'luis.patternsPage.deletePatternsModalDescription',
        defaultMessage: 'Are you sure you want to delete the selected pattern(s)?'
    },
    createPatternToastStart: {
        id: 'luis.patternsPage.createPatternToastStart',
        defaultMessage: 'Creating pattern ...'
    },
    createPatternToastSuccess: {
        id: 'luis.patternsPage.createPatternToastSuccess',
        defaultMessage: 'Create pattern completed'
    },
    createPatternToastFailed: {
        id: 'luis.patternsPage.createPatternToastFailed',
        defaultMessage: 'Create pattern failed.'
    },
    updatePatternToastStart: {
        id: 'luis.patternsPage.updatePatternToastStart',
        defaultMessage: 'Updating pattern(s) ...'
    },
    updatePatternToastSuccess: {
        id: 'luis.patternsPage.updatePatternToastSuccess',
        defaultMessage: 'Update pattern(s) completed'
    },
    updatePatternToastFailed: {
        id: 'luis.patternsPage.updatePatternToastFailed',
        defaultMessage: 'Update pattern(s) failed.'
    },
    deletePatternToastStart: {
        id: 'luis.patternsPage.deletePatternToastStart',
        defaultMessage: 'Deleting pattern(s) ...'
    },
    deletePatternToastSuccess: {
        id: 'luis.patternsPage.deletePatternToastSuccess',
        defaultMessage: 'Delete pattern(s) completed'
    },
    deletePatternToastFailed: {
        id: 'luis.patternsPage.deletePatternToastFailed',
        defaultMessage: 'Delete pattern(s) failed.'
    }
});
